module.exports = "/lucky-balls/img/regular_game/header_betole.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_betole.png
// module id = 1143
// module chunks = 0